import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/Dashboard',
      name: 'Home',
      component: () => import('@/containers/DefaultContainer'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/Dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard')
        },
        
        {
          path: '/Profile',
          meta: { label: 'Profile' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Settings/profile')
            },
            {
              path: '/changePassword',
              meta: { label: 'Change Password' },
              name: 'ChangePassword',
              component: () => import('@/views/Settings/changePassword'),
            },
          ]
        },
        

        {
          path: '/Mammals',
          meta: { label: 'Mammals' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/Mammals/mammals')
            },
            {
              path: ':id',
              meta: { label: 'Mammal Details' },
              name: 'Mammal Details',
              component: () => import('@/views/Mammals/mammal')
            },
            {
              path: '/addMammal',
              props: true,
              meta: { label: 'Add Mammal' },
              name: 'Add Mammal',
              component: () => import('@/views/Mammals/addMammal')
            },

            {
              path: '/editMammal/:id',
              props: true,
              meta: { label: 'Edit Mammal' },
              name: 'AdEditd Mammal',
              component: () => import('@/views/Mammals/editMammal')
            },

            
          ]
        },

        // {
        //   path: '/Map',
        //   meta: { label: 'Map' },
        //   component: {
        //     render(c) { return c('router-view') }
        //   },
        //   children: [
        //     {
        //       path: '',
        //       component: () => import('@/views/Map/map'),
        //     },
        //   ]
        // },
        {
          path: '/Users',
          meta: { label: 'Users' },
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: () => import('@/views/users/users'),
            },
            {
              path: ':id',
              meta: { label: 'User Details' },
              name: 'User',
              component: () => import('@/views/users/user'),
            },
            {
              path: '/addUser',
              meta: { label: 'Add User' },
              name: 'AddUser',
              component: () => import('@/views/users/addUser'),
            },
          ]
        },
        
       
        
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/pages/Login')
    },
    {
      path: '*',
      name: 'NotFound',
      props: true,
      component: () => import('../views/pages/Page404'),
      meta: {
        description: 'App 404 Page',
        requiresAuth: false
      }
    },
    {
      path: '/ServerError',
      name: 'ServerError',
      props: true,
      component: () => import('../views/pages/Page500'),
      meta: {
        description: 'App Server Error Page',
        requiresAuth: false
      }
    },

  ]
})

router.beforeEach((to, from, next) => {
  if (localStorage.getItem('token')) {
    axios({
      method: "POST",
      url: "/validate/token",
      headers: {
        "x-auth-token": localStorage.getItem("token")
      }
    })
      .then(response => {
        if (!response.data.status) {
          localStorage.removeItem("token");
          localStorage.removeItem("role");
          store.commit("logoutUser");
          next({
            name: 'Login'
          })
          return
        }
      })
  }
  if (to.matched.some(route => route.meta.requiresAuth) && !store.state.isLoggedIn) {
    next({
      name: 'Login'
    })
    return
  }
  if (to.path === '/login' && store.state.isLoggedIn) {
    next({
      path: '/'
    })
    return
  }
  next()
})

export default router

